import AmexCardIcon from "../Icons/AmexCardIcon";
import DefaultCardIcon from "../Icons/DefaultCardIcon";
import MasterCardIcon from "../Icons/MasterCardIcon";
import React from "react";
import { DiscoverCardIcon, DiscoverDinerCardIcon, JCBCardIcon, RuPayCardIcon, UnionPayCardIcon }
  from "../Icons";
import VisaCardIcon from "../Icons/VisaCardIcon";
import { Theme, useMediaQuery } from "@mui/material";


interface ICardProviderDetails {
  cardBrand: string;
  lastFourDigits: string;
  textClass?:string;
  hideIcon?: boolean;
}

export const providerIcon = (cardBrand: string) => {
  if (cardBrand.toLowerCase() === "visa") {
    return <VisaCardIcon />;
  } else if (cardBrand.toLowerCase() === "mastercard") {
    return <MasterCardIcon />;
  } else if (cardBrand.toLowerCase() === "american_express") {
    return <AmexCardIcon />;
  } else if (cardBrand.toLowerCase() === "discover") {
    return <DiscoverCardIcon />;
  } else if (cardBrand.toLowerCase() === "discover_diners") {
    return <DiscoverDinerCardIcon />;
  } else if (cardBrand.toLowerCase() === "jcb") {
    return <JCBCardIcon />;
  } else if (cardBrand.toLowerCase() === "rupay") {
    return <RuPayCardIcon />;
  } else if (cardBrand.toLowerCase() === "china_unionpay") {
    return <UnionPayCardIcon />;
  } else {
    return <DefaultCardIcon />;
  }
};

const CardProviderDetails = ({ cardBrand, lastFourDigits, textClass, hideIcon=false }: ICardProviderDetails) => {
  const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <div className="flex items-center gap-1">
      {!hideIcon && <div className="flex-shrink-0">{providerIcon(cardBrand)}</div>}
      <div className={`text-sm font-semibold flex flex-wrap items-center capitalize gap-x-1 ${textClass}`}>
        <span>{cardBrand.toLowerCase().split("_").join(" ")}</span>
        <span className="relative top-1">{isLargeScreen ? "**** **** ****" : "****"} {lastFourDigits}</span>
      </div>
    </div>
  );
};

export default CardProviderDetails;
